import { createSelector } from "reselect";
import { IRootReducer } from "../Reducers/RootReducer";

export const usaWKTSelector = createSelector(
    (state: IRootReducer) => state.commonReducer.usaWKT,
    (usaWKT: string) => usaWKT
);